import { ProductThumb as BaseProductThumb, type ProductThumbProps, THUMB_PIXELS } from "@milqit/ui";

import { resizedImage, resizedSrcSet } from "@/lib/cloudinary-image";

/**
 * The shared thumbnail with uploads cut to its size by Cloudinary, so a table of 44 px thumbnails
 * doesn't download every full-size photo. `displayPx` covers frames a className enlarges.
 */
export function ProductThumb({
  displayPx,
  ...props
}: Omit<ProductThumbProps, "srcSet" | "sizes"> & { displayPx?: number }) {
  const px = displayPx ?? THUMB_PIXELS[props.size ?? "sm"];
  return (
    <BaseProductThumb
      {...props}
      src={resizedImage(props.src, px)}
      srcSet={resizedSrcSet(props.src, px)}
    />
  );
}
